export const translations = {
  en: {
    dashboard: 'Dashboard',
    templates: 'Templates',
    analytics: 'Analytics',
    resources: 'Resources',
    videos: 'Videos',
    signOut: 'Sign Out',
    welcome: 'Hello',
    teacher: 'Teacher',
    parent: 'Parent',
    admin: 'Admin',
    myChildren: 'My Children',
    myStudents: 'My Students',
    viewProgress: 'View Progress',
    studentProfile: 'Student Profile',
    assessments: 'Assessments',
    compare: 'Compare',
    timeline: 'Timeline',
    portfolio: 'Portfolio',
    homeActivity: 'Home Activity',
    impact: 'Attendance & Impact',
    createProfile: 'Create New Profile',
    template: 'Template',
    assessmentType: 'Assessment Type',
    profileName: 'Profile Name',
    create: 'Create',
    saveProfile: 'Save Profile',
    exportPdf: 'Export PDF',
    generateAssignment: 'Generate Assignment',
    rename: 'Rename',
    delete: 'Delete',
    recentActivity: 'Recent Activity',
    processed: 'Processed',
    importXlsx: 'Import XLSX',
    importSchema: 'Auto-Import Schema',
    importShared: 'Import Shared Template',
    export: 'Export',
    deleteAll: 'Delete All',
    addStudent: 'Add Student',
    parentDirectory: 'Parent Directory',
    studentDirectory: 'Student Directory',
    staff: 'Staff',
    logs: 'Logs',
    communication: 'Communication',
    systemStats: 'System Stats',
    accessDenied: 'Access Denied',
    pageNotFound: 'Page Not Found',
    goHome: 'Back to Dashboard',
    broadcastUpdate: 'Broadcast Update',
    broadcastMessage: 'Broadcast Message',
    composeNew: 'Compose New',
    sentHistory: 'Sent History',
    sentBy: 'Sent by',
    activityLog: 'System Activity Log',
    allActions: 'All Actions',
    timeCol: 'Time',
    userCol: 'User',
    actionCol: 'Action',
    detailsCol: 'Details',
    manageParentsFor: 'Manage Parents for',
    assign: 'Assign',
    unassign: 'Unassign',
    done: 'Done',
    studentInfo: 'Student Information',
    basicDetails: 'Basic Details',
    ageLabel: 'Age',
    dobLabel: 'Date of Birth',
    genderLabel: 'Gender',
    linkedParents: 'Linked Parents',
    extendedMeta: 'Extended Metadata',
    close: 'Close',
    editStudentTitle: 'Edit Student',
    fullName: 'Full Name',
    cancel: 'Cancel',
    updateStudent: 'Update',
    editParentTitle: 'Edit Parent',
    credentialsLabel: 'Credentials',
    usernameLogin: 'Username (Login)',
    confirmDeleteTitle: 'Confirm Delete',
    confirmDeleteMsg: 'Are you sure? This cannot be undone.',
    confirmDeleteAllTitle: 'Delete All — Are you sure?',
    confirmDeleteAllMsg:
      'This will permanently delete all records. Type DELETE to confirm.',
    typeDeletePlaceholder: 'Type DELETE',
    addNewTeacher: 'Add New Teacher',
    systemAccess: 'System Access Control',
    openUserManagement: 'Open User Management',
    quickNav: 'Quick Navigation',
    searchLabel: 'Search...',
    searchParents: 'Search parents...',
    syncBtn: 'Sync',
    importBtn: 'Import',
    assignTeacher: 'Assign Teacher',
    kidsLabel: 'Kids',
    assessmentsWeek: 'This Week',
    avgMastery: 'Avg Mastery',
    noTeacher: 'No Teacher',
    noParent: 'No Parent',
    neverAssessed: 'Never Assessed',
    lastSync: 'Last AlfaCRM Sync',
    teacherOverview: 'Teacher Overview',
    groupsLabel: 'Groups',
    lastAssessmentLabel: 'Last Assessment',
    dataHealth: 'Data Health',
    neverLabel: 'Never',
    syncParentNamesBtn: 'Sync Parent Names',
  },
  ru: {
    dashboard: 'Дашборд',
    templates: 'Шаблоны',
    analytics: 'Аналитика',
    resources: 'Ресурсы',
    videos: 'Видео',
    signOut: 'Выйти',
    welcome: 'Здравствуйте',
    teacher: 'Учитель',
    parent: 'Родитель',
    admin: 'Админ',
    myChildren: 'Мои дети',
    myStudents: 'Мои студенты',
    viewProgress: 'Прогресс',
    studentProfile: 'Профиль студента',
    assessments: 'Оценки',
    compare: 'Сравнение',
    timeline: 'Хронология',
    portfolio: 'Портфолио',
    homeActivity: 'Занятия дома',
    impact: 'Посещаемость и эффект',
    createProfile: 'Создать новый профиль',
    template: 'Шаблон',
    assessmentType: 'Тип оценки',
    profileName: 'Название профиля',
    create: 'Создать',
    saveProfile: 'Сохранить профиль',
    exportPdf: 'Экспорт PDF',
    generateAssignment: 'Домашнее задание',
    rename: 'Переименовать',
    delete: 'Удалить',
    recentActivity: 'Последние действия',
    processed: 'Обработано',
    importXlsx: 'Импорт XLSX',
    importSchema: 'Импорт схемы',
    importShared: 'Импорт общего шаблона',
    export: 'Экспорт',
    deleteAll: 'Удалить все',
    addStudent: 'Добавить ученика',
    parentDirectory: 'Список родителей',
    studentDirectory: 'Список учеников',
    staff: 'Персонал',
    logs: 'Логи',
    communication: 'Связь',
    systemStats: 'Статистика',
    accessDenied: 'Доступ запрещен',
    pageNotFound: 'Страница не найдена',
    goHome: 'На главную',
    broadcastUpdate: 'Рассылка',
    broadcastMessage: 'Новое сообщение',
    composeNew: 'Создать',
    sentHistory: 'История рассылок',
    sentBy: 'Отправил',
    activityLog: 'Журнал активности',
    allActions: 'Все действия',
    timeCol: 'Время',
    userCol: 'Пользователь',
    actionCol: 'Действие',
    detailsCol: 'Детали',
    manageParentsFor: 'Родители ученика',
    assign: 'Назначить',
    unassign: 'Убрать',
    done: 'Готово',
    studentInfo: 'Информация об ученике',
    basicDetails: 'Основная информация',
    ageLabel: 'Возраст',
    dobLabel: 'Дата рождения',
    genderLabel: 'Пол',
    linkedParents: 'Родители',
    extendedMeta: 'Метаданные',
    close: 'Закрыть',
    editStudentTitle: 'Редактировать ученика',
    fullName: 'Полное имя',
    cancel: 'Отмена',
    updateStudent: 'Сохранить',
    editParentTitle: 'Редактировать родителя',
    credentialsLabel: 'Учётные данные',
    usernameLogin: 'Логин',
    confirmDeleteTitle: 'Подтвердить удаление',
    confirmDeleteMsg: 'Вы уверены? Это действие нельзя отменить.',
    confirmDeleteAllTitle: 'Удалить всё — вы уверены?',
    confirmDeleteAllMsg:
      'Это удалит все записи навсегда. Введите DELETE для подтверждения.',
    typeDeletePlaceholder: 'Введите DELETE',
    addNewTeacher: 'Добавить учителя',
    systemAccess: 'Управление доступом',
    openUserManagement: 'Управление пользователями',
    quickNav: 'Навигация',
    searchLabel: 'Поиск...',
    searchParents: 'Поиск родителей...',
    syncBtn: 'Синхронизация',
    importBtn: 'Импорт',
    assignTeacher: 'Назначить учителя',
    kidsLabel: 'Дети',
    assessmentsWeek: 'За неделю',
    avgMastery: 'Ср. успеваемость',
    noTeacher: 'Без учителя',
    noParent: 'Без родителя',
    neverAssessed: 'Без оценки',
    lastSync: 'Последняя синхронизация',
    teacherOverview: 'Обзор учителей',
    groupsLabel: 'Групп',
    lastAssessmentLabel: 'Последняя оценка',
    dataHealth: 'Качество данных',
    neverLabel: 'Никогда',
    syncParentNamesBtn: 'Синхронизировать имена',
  },
};
